import { gql } from '@apollo/client';

export const SETTINGS_QUERY = gql`
  query settings {
    settings {
      id
      key
      value
      description
    }
  }
`;

export interface RawSetting {
  id: number;
  key: string;
  value: string;
  description: string | null;
}

export interface SettingsQueryResult {
  settings: RawSetting[];
}
